{
  "instances": {
    "heapdump": {
      "label": "Heap Dump",
      "download": "Télécharger le Heap Dump",
      "warn_dump_expensive": "Cette opération peut être coûteuse en terme de CPU et d'espace disque.",
      "warn_sensitive_data": "Un heap dump peut contenir des informations sensibles. Veuillez manipuler ces données avec précautions."
    }
  }
}
